import { render } from "./EditReportUser.vue?vue&type=template&id=415cdf64"
import script from "./EditReportUser.vue?vue&type=script&lang=js"
export * from "./EditReportUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__